import { render, staticRenderFns } from "./EditDealDocumentType.vue?vue&type=template&id=237ac016"
import script from "./EditDealDocumentType.vue?vue&type=script&lang=js"
export * from "./EditDealDocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports